import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { NvDesignLibraryModule } from 'Src/nvps-libraries/design/nv-design-library.module';

import { ExitViewModule } from '../exit-view/exit-view.component.module';
import { UpgradeNg1Helpers } from './../../helpers/upgrade/upgrade-ng1.helper';
import { ActivitySettingsModule } from './activities-settings/activities-settings.module';
import { AssessmentsSettingsModule } from './assessments-settings/assesments-settings.module';
import { SettingsHeaderComponent } from './settings-header/settings-header.component';
import { SettingsLeftNavComponent } from './settings-left-nav/settings-left-nav.component';
import { SettingsComponent } from './settings.component';

@NgModule({
  imports: [
    CommonModule,
    ExitViewModule,
    NvDesignLibraryModule,
    ActivitySettingsModule,
    MatTabsModule,
    AssessmentsSettingsModule,
  ],
  declarations: [
    SettingsComponent,
    SettingsHeaderComponent,
    SettingsLeftNavComponent,
    UpgradeNg1Helpers.upgradeComponent({
      selector: 'credit-metrics',
      inputs: ['currentSchool'],
    }),
    UpgradeNg1Helpers.upgradeComponent({
      selector: 'regents-metrics',
      inputs: ['currentSchool'],
    }),
    UpgradeNg1Helpers.upgradeComponent({
      selector: 'grad-planning-metrics',
      inputs: ['currentSchool'],
    }),
    UpgradeNg1Helpers.upgradeComponent({
      selector: 'distance-to-grad-component',
    }),
    UpgradeNg1Helpers.upgradeComponent({
      selector: 'master-program',
      inputs: ['currentSchool'],
    }),
    UpgradeNg1Helpers.upgradeComponent({
      selector: 'no-supports',
    }),
    UpgradeNg1Helpers.upgradeComponent({
      selector: 'supports-table',
      inputs: ['currentSchool', 'currentSchool', 'currentUser', 'studentSupports$'],
    }),
    UpgradeNg1Helpers.upgradeComponent({
      selector: 'supports-roster',
      inputs: ['attendanceRecords', 'studentSupports$'],
    }),
    UpgradeNg1Helpers.upgradeComponent({
      selector: 'absent-students-list',
      inputs: ['attendanceRecords', 'studentSupports$'],
    }),
    UpgradeNg1Helpers.upgradeComponent({
      selector: 'manage-users',
      inputs: ['currentSchool', 'currentUser', 'schoolUsers'],
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SettingsModule {}
